import { motion, useReducedMotion } from 'framer-motion'
import PropTypes from 'prop-types'

import { classNames } from '../../helpers'
import { DURATION, EASE, SPRING } from './tokens'

// Bestätigung nach einer abgeschlossenen Aktion. Der Kreis springt auf, danach
// zeichnet sich der Haken. Spielt einmal beim Mounten.
const SuccessCheck = ({ className }) => {
  const reducedMotion = useReducedMotion()

  return (
    <motion.span
      aria-hidden='true'
      className={classNames(
        'flex size-12 shrink-0 items-center justify-center rounded-full bg-green-100',
        className
      )}
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={SPRING.snappy}
    >
      <svg viewBox='0 0 24 24' fill='none' className='size-6 text-green-600'>
        <motion.path
          d='M5 12.5l4.5 4.5L19 7.5'
          stroke='currentColor'
          strokeWidth={2.5}
          strokeLinecap='round'
          strokeLinejoin='round'
          initial={{ pathLength: reducedMotion ? 1 : 0 }}
          animate={{ pathLength: 1 }}
          transition={{ delay: 0.15, duration: DURATION.slow, ease: EASE.out }}
        />
      </svg>
    </motion.span>
  )
}

SuccessCheck.propTypes = {
  className: PropTypes.string
}

SuccessCheck.defaultProps = {
  className: undefined
}

export default SuccessCheck
